// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2TKPz","rightAdornment":"Header_rightAdornment__MILl5"};